import { observable } from "mobx";

export default class PostMessageModel {
    id = Math.random();
    @observable postid;
    @observable status = "";
    @observable text = '';
    @observable createddatetime = null;
    @observable createduserid = null;

    constructor(postid, status, text, createddatetime) {
        this.postid = postid;
        if (typeof (status) !== 'undefined') this.status = status;
        if (typeof (text) !== 'undefined') this.text = text;
        if (typeof (createddatetime) !== 'undefined') this.createddatetime = createddatetime;
    }
}


// WEBPACK FOOTER //
// ./src/models/PostMessageModel.js